import { useEffect } from 'react';
import { MessageView } from 'neon-design-system';
import { createStyles, makeStyles } from '@material-ui/styles';
import { config } from '../../config';
import { logEvent } from '../../utils/logger';
import { useNeonUserId } from '../../providers/NeonUserIdProvider';

const useStyles = makeStyles(() =>
  createStyles({
    alignCenter: {
      position: 'absolute',
      width: '100%',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }
  })
);

export const UnauthorisedAccessError = () => {
  const classes = useStyles();
  const { neonUserId } = useNeonUserId();

  useEffect(() => {
    if (neonUserId) {
      logEvent({
        event: 'auth_unauthorized',
        level: 'Warning',
        neonUserId
      });
    }
  }, [neonUserId]);

  return (
    <div className={classes.alignCenter}>
      <MessageView
        styleName="primary"
        size="medium"
        title="You don’t have permissions to access this application."
        primaryAction={{
          label: 'Back to the dashboard',
          onClick: () => {
            window.location.href = config.landingPageUrl;
          }
        }}
      >
        If you believe you require access to this application, please contact support.
      </MessageView>
    </div>
  );
};

export default UnauthorisedAccessError;
